exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MzrXA5i4ZW1P7bClGZcR1{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;overflow:hidden}", ""]);

// exports
exports.locals = {
	"compactRecipientRow": "MzrXA5i4ZW1P7bClGZcR1"
};